import React from 'react';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';

import ClientUsersComponent from '@/components/ClientsPage/ClientUsers/ClientUsersComponent';
import { useClientUsers } from '@/hooks/useClientUsers';

const ClientUsersContainer = () => {
  const { id, status } = useParams();
  const intl = useIntl();
  const { useUsersList } = useClientUsers(id);
  const { data: users = [], isLoading } = useUsersList();

  return (
    <ClientUsersComponent 
      id={id} 
      intl={intl} 
      status={status} 
      users={users} 
      loading={isLoading}
    />
  );
};

export default ClientUsersContainer;

